// Node Asset Overview - English
export default {
  asset: {
    totalValue: "Total Asset Value",
    totalExplain:
      "Total asset balance is derived from supported tokens' values, converted to USDT for all main and token balances on the address.",
    supportedPrefix: "Currently supports",
    supportedLinkText: "317 tokens",
    tronNote: "On Tron, only TRX and USDT are currently supported",
    updateSuffix: " updated",
  },
  balance: {
    mainBalanceSuffix: " Balance:",
    usdtBalance: "USDT Balance:",
    btcBalance: "BTC Balance",
    approxUSDT: "(≈{value}\u00A0USDT)",
    currentBalancePrefix: "Current Balance:",
    remark: "Remark:",
  },
};
